export const createSubmissionClaim = () => {
    let claimed = false;
    return {
        tryClaim: () => {
            if (claimed)
                return false;
            claimed = true;
            return true;
        },
        isClaimed: () => claimed,
        reset: () => {
            claimed = false;
        },
    };
};
/**
 * TS-12 — should a listening stall be reported?
 *
 * Only when the backend still claims to be listening and the assistant is not
 * mid-utterance. Anything else means the turn moved on between the timer being
 * armed and it firing.
 */
export const shouldReportListeningStall = (state) => state.serverRecordingRequested && !state.assistantSpeaking;
/** TS-12 — the `fe_error` payload sent when a listening stall is detected. */
export const buildListeningStallReport = (stallMs) => ({
    type: 'fe_error',
    context: 'listening_stall',
    message: `No backend activity for ${stallMs}ms while listening`,
});
/**
 * TS-19 — should a stalled coding submission be reported?
 *
 * The counterpart to the listening stall, for the OTHER half of the interview
 * loop. On sending `code_submission_complete` the UI optimistically shows
 * "Analyzing…" → "Understanding your response…" and then waits with no timeout
 * of its own, so any backend path that receives the submission but drives no
 * turn leaves the candidate staring at that forever. This is the transition the
 * reported hang always happened on: coding editor → main screen, on submit or
 * skip.
 *
 * Report only while we are genuinely still waiting: nothing has been received
 * for this submission and the assistant is not already mid-utterance (which
 * would mean the response arrived and the timer simply lost the race).
 */
export const shouldReportSubmissionStall = (state) => state.awaitingSubmissionResponse && !state.assistantSpeaking;
/** TS-19 — the `fe_error` payload sent when a coding submission gets no reply. */
export const buildSubmissionStallReport = (stallMs, action) => ({
    type: 'fe_error',
    context: 'coding_submission_stall',
    message: `No backend response ${stallMs}ms after a coding ${action}`,
});
